export const translations = {
  it: {
    nav: {
      home: "Home",
      menu: "Menu",
      gallery: "Galleria",
      reservations: "Prenota",
      contact: "Contatti",
      book: "Prenota tavolo",
    },
    hero: {
      eyebrow: "Caffè · Cucina · Sorriso",
      title_1: "Un sorriso",
      title_2: "in ogni",
      title_3: "boccone.",
      subtitle:
        "Dall'espresso del mattino alla cena a lume di candela. Un bistrot italiano dove tempo, sapore e ospitalità si incontrano.",
      cta_primary: "Prenota un tavolo",
      cta_secondary: "Scopri il menu",
    },
    about: {
      eyebrow: "La nostra storia",
      title: "Una piccola casa, una grande tavola.",
      body_1:
        "Caffè & Cucina Sorriso nasce dall'amore per i piccoli rituali italiani: il primo caffè all'alba, il pranzo lento condiviso con chi si ama, il bicchiere di vino che chiude la giornata.",
      body_2:
        "La nostra cucina celebra ingredienti stagionali, fornitori locali e ricette di famiglia reinterpretate con grazia contemporanea.",
      stats: [
        { value: "4.4★", label: "343 recensioni Google" },
        { value: "Harras", label: "Sendling, München" },
      ],
    },
    menu: {
      eyebrow: "Menu",
      title: "Dal caffè della mattina alla cena.",
      subtitle:
        "Una piccola selezione cambia ogni stagione. Chiedi al nostro staff per i piatti del giorno.",
      categories: {
        coffee: "Caffè & Bevande",
        breakfast: "Colazione",
        lunch_dinner: "Pranzo & Cena",
        dessert: "Dolci",
      },
      view_all: "Vedi tutto il menu",
    },
    gallery: {
      eyebrow: "Galleria",
      title: "Il luogo, in immagini.",
      subtitle: "Atmosfere, dettagli e piatti che raccontano chi siamo.",
    },
    reservation: {
      eyebrow: "Prenotazione",
      title: "Riserva il tuo tavolo.",
      subtitle:
        "Confermiamo entro poche ore. Per gruppi superiori a 8 persone, contattaci direttamente.",
      name: "Nome e cognome",
      email: "Email",
      phone: "Telefono",
      date: "Data",
      pick_date: "Seleziona una data",
      time: "Orario",
      pick_time: "Seleziona un orario",
      guests: "Persone",
      pick_guests: "Numero di ospiti",
      occasion: "Occasione (opzionale)",
      pick_occasion: "Seleziona un'occasione",
      occasions: {
        none: "Nessuna in particolare",
        birthday: "Compleanno",
        anniversary: "Anniversario",
        business: "Lavoro",
        date: "Cena romantica",
      },
      notes: "Richieste speciali",
      notes_placeholder: "Allergie, preferenze, posizione del tavolo...",
      submit: "Conferma prenotazione",
      submitting: "Invio in corso...",
      success: "Prenotazione ricevuta. Ti contatteremo a breve.",
      error: "Qualcosa è andato storto. Riprova.",
    },
    contact: {
      eyebrow: "Contatti",
      title: "Passa a trovarci.",
      subtitle:
        "Siamo qui per te, dalla prima moka del mattino fino alla luce calda della sera.",
      address_label: "Indirizzo",
      hours_label: "Orari",
      phone_label: "Telefono",
      email_label: "Email",
      hours: [
        { day: "Lun – Ven", time: "08:30 – 18:00" },
        { day: "Sab", time: "08:30 – 17:00" },
        { day: "Dom", time: "10:00 – 17:30" },
      ],
      form_title: "Scrivici",
      form_name: "Nome",
      form_email: "Email",
      form_subject: "Oggetto",
      form_message: "Messaggio",
      form_submit: "Invia messaggio",
      form_submitting: "Invio...",
      form_success: "Messaggio inviato. Grazie!",
      form_error: "Errore nell'invio. Riprova.",
    },
    footer: {
      tagline: "Caffè · Cucina · Sorriso.",
      rights: "Tutti i diritti riservati.",
      made_with: "Disegnato con cura.",
    },
  },
  en: {
    nav: {
      home: "Home",
      menu: "Menu",
      gallery: "Gallery",
      reservations: "Reserve",
      contact: "Contact",
      book: "Book a table",
    },
    hero: {
      eyebrow: "Coffee · Kitchen · Sorriso",
      title_1: "A smile",
      title_2: "in every",
      title_3: "bite.",
      subtitle:
        "From morning espresso to candlelit dinners. An Italian bistrot where time, flavour and hospitality meet.",
      cta_primary: "Book a table",
      cta_secondary: "Discover the menu",
    },
    about: {
      eyebrow: "Our story",
      title: "A small house, a generous table.",
      body_1:
        "Caffè & Cucina Sorriso was born from a love of small Italian rituals: the first coffee at dawn, the unhurried lunch shared with loved ones, the glass of wine that closes the day.",
      body_2:
        "Our kitchen celebrates seasonal ingredients, local farmers and family recipes reimagined with quiet, contemporary grace.",
      stats: [
        { value: "4.4★", label: "343 Google reviews" },
        { value: "Harras", label: "Sendling, Munich" },
      ],
    },
    menu: {
      eyebrow: "Menu",
      title: "From morning coffee to dinner.",
      subtitle:
        "A small selection changes with the seasons. Ask our team about today's specials.",
      categories: {
        coffee: "Coffee & Drinks",
        breakfast: "Breakfast",
        lunch_dinner: "Lunch & Dinner",
        dessert: "Dessert",
      },
      view_all: "See the full menu",
    },
    gallery: {
      eyebrow: "Gallery",
      title: "The place, in pictures.",
      subtitle: "Atmospheres, details and dishes that tell who we are.",
    },
    reservation: {
      eyebrow: "Reservation",
      title: "Reserve your table.",
      subtitle:
        "We confirm within a few hours. For groups over 8, please contact us directly.",
      name: "Full name",
      email: "Email",
      phone: "Phone",
      date: "Date",
      pick_date: "Pick a date",
      time: "Time",
      pick_time: "Select a time",
      guests: "Guests",
      pick_guests: "Number of guests",
      occasion: "Occasion (optional)",
      pick_occasion: "Choose an occasion",
      occasions: {
        none: "Nothing in particular",
        birthday: "Birthday",
        anniversary: "Anniversary",
        business: "Business",
        date: "Romantic dinner",
      },
      notes: "Special requests",
      notes_placeholder: "Allergies, preferences, table location...",
      submit: "Confirm reservation",
      submitting: "Sending...",
      success: "Reservation received. We'll be in touch shortly.",
      error: "Something went wrong. Please try again.",
    },
    contact: {
      eyebrow: "Contact",
      title: "Come visit us.",
      subtitle:
        "We're here for you, from the first morning moka to the warm light of evening.",
      address_label: "Address",
      hours_label: "Hours",
      phone_label: "Phone",
      email_label: "Email",
      hours: [
        { day: "Mon – Fri", time: "08:30 – 18:00" },
        { day: "Sat", time: "08:30 – 17:00" },
        { day: "Sun", time: "10:00 – 17:30" },
      ],
      form_title: "Write to us",
      form_name: "Name",
      form_email: "Email",
      form_subject: "Subject",
      form_message: "Message",
      form_submit: "Send message",
      form_submitting: "Sending...",
      form_success: "Message sent. Thank you!",
      form_error: "Error sending. Please try again.",
    },
    footer: {
      tagline: "Coffee · Kitchen · Sorriso.",
      rights: "All rights reserved.",
      made_with: "Designed with care.",
    },
  },
  de: {
    nav: {
      home: "Start",
      menu: "Speisekarte",
      gallery: "Galerie",
      reservations: "Reservieren",
      contact: "Kontakt",
      book: "Tisch reservieren",
    },
    hero: {
      eyebrow: "Kaffee · Küche · Sorriso",
      title_1: "Ein Lächeln",
      title_2: "in jedem",
      title_3: "Bissen.",
      subtitle:
        "Vom morgendlichen Espresso bis zum Abendessen bei Kerzenschein. Ein italienisches Bistro, in dem Zeit, Geschmack und Gastfreundschaft zusammenkommen.",
      cta_primary: "Tisch reservieren",
      cta_secondary: "Speisekarte entdecken",
    },
    about: {
      eyebrow: "Unsere Geschichte",
      title: "Ein kleines Haus, ein großzügiger Tisch.",
      body_1:
        "Caffè & Cucina Sorriso wurde aus der Liebe zu kleinen italienischen Ritualen geboren: dem ersten Kaffee bei Sonnenaufgang, dem geruhsamen Mittagessen mit den Liebsten, dem Glas Wein zum Tagesausklang.",
      body_2:
        "Unsere Küche feiert saisonale Zutaten, lokale Bauern und Familienrezepte, neu interpretiert mit stiller, zeitgenössischer Anmut.",
      stats: [
        { value: "4.4★", label: "343 Google-Bewertungen" },
        { value: "Harras", label: "Sendling, München" },
      ],
    },
    menu: {
      eyebrow: "Speisekarte",
      title: "Vom Morgenkaffee bis zum Abendessen.",
      subtitle:
        "Eine kleine Auswahl wechselt mit den Jahreszeiten. Fragen Sie unser Team nach den heutigen Empfehlungen.",
      categories: {
        coffee: "Kaffee & Getränke",
        breakfast: "Frühstück",
        lunch_dinner: "Mittag- & Abendessen",
        dessert: "Dessert",
      },
      view_all: "Komplette Speisekarte ansehen",
    },
    gallery: {
      eyebrow: "Galerie",
      title: "Der Ort, in Bildern.",
      subtitle: "Atmosphären, Details und Gerichte, die erzählen, wer wir sind.",
    },
    reservation: {
      eyebrow: "Reservierung",
      title: "Reservieren Sie Ihren Tisch.",
      subtitle:
        "Wir bestätigen innerhalb weniger Stunden. Für Gruppen ab 8 Personen kontaktieren Sie uns bitte direkt.",
      name: "Vor- und Nachname",
      email: "E-Mail",
      phone: "Telefon",
      date: "Datum",
      pick_date: "Datum wählen",
      time: "Uhrzeit",
      pick_time: "Uhrzeit wählen",
      guests: "Gäste",
      pick_guests: "Anzahl der Gäste",
      occasion: "Anlass (optional)",
      pick_occasion: "Anlass wählen",
      occasions: {
        none: "Nichts Besonderes",
        birthday: "Geburtstag",
        anniversary: "Jubiläum",
        business: "Geschäftlich",
        date: "Romantisches Dinner",
      },
      notes: "Besondere Wünsche",
      notes_placeholder: "Allergien, Vorlieben, Tischposition...",
      submit: "Reservierung bestätigen",
      submitting: "Wird gesendet...",
      success: "Reservierung erhalten. Wir melden uns in Kürze.",
      error: "Etwas ist schiefgelaufen. Bitte erneut versuchen.",
    },
    contact: {
      eyebrow: "Kontakt",
      title: "Besuchen Sie uns.",
      subtitle:
        "Wir sind für Sie da, von der ersten Moka am Morgen bis zum warmen Licht des Abends.",
      address_label: "Adresse",
      hours_label: "Öffnungszeiten",
      phone_label: "Telefon",
      email_label: "E-Mail",
      hours: [
        { day: "Mo – Sa", time: "10:00 – 21:00" },
        { day: "So", time: "Geschlossen" },
      ],
      form_title: "Schreiben Sie uns",
      form_name: "Name",
      form_email: "E-Mail",
      form_subject: "Betreff",
      form_message: "Nachricht",
      form_submit: "Nachricht senden",
      form_submitting: "Senden...",
      form_success: "Nachricht gesendet. Danke!",
      form_error: "Fehler beim Senden. Bitte erneut versuchen.",
    },
    footer: {
      tagline: "Kaffee · Küche · Sorriso.",
      rights: "Alle Rechte vorbehalten.",
      made_with: "Mit Sorgfalt gestaltet.",
    },
  },
};

export const venueInfo = {
  name: "Caffè & Cucina Sorriso",
  neighborhood: "Sendling · München",
  address: "Plinganserstraße 38A, 81369 München",
  phone: "+49 89 74746299",
  email: "info@caffecucinasorriso.de",
  mapsUrl:
    "https://www.google.com/maps?q=Plinganserstra%C3%9Fe+38A+81369+M%C3%BCnchen+Caff%C3%A8+%26+Cucina+Sorriso&output=embed",
  rating: "4.4",
  reviewsCount: "343",
  social: {
    instagram: "https://instagram.com",
    facebook: "https://facebook.com",
  },
};

export const menuData = {
  coffee: [
    { name: { it: "Espresso", en: "Espresso", de: "Espresso" }, desc: { it: "Miscela italiana, estrazione classica.", en: "Italian blend, classic extraction.", de: "Italienische Mischung, klassische Extraktion." }, price: "€1,80" },
    { name: { it: "Cappuccino", en: "Cappuccino", de: "Cappuccino" }, desc: { it: "Latte intero, schiuma vellutata.", en: "Whole milk, velvety foam.", de: "Vollmilch, samtiger Schaum." }, price: "€2,80" },
    { name: { it: "Latte Macchiato", en: "Latte Macchiato", de: "Latte Macchiato" }, desc: { it: "Tre strati, latte, espresso e schiuma.", en: "Three layers: milk, espresso, foam.", de: "Drei Schichten: Milch, Espresso, Schaum." }, price: "€3,20" },
    { name: { it: "Cioccolata calda", en: "Hot Chocolate", de: "Heiße Schokolade" }, desc: { it: "Cacao fondente, panna fresca.", en: "Dark cocoa, fresh cream.", de: "Dunkler Kakao, frische Sahne." }, price: "€3,80" },
  ],
  breakfast: [
    { name: { it: "Cornetto", en: "Croissant", de: "Croissant" }, desc: { it: "Sfoglia al burro, vuoto o con marmellata.", en: "Butter pastry, plain or with jam.", de: "Butter-Croissant, natur oder mit Marmelade." }, price: "€2,50" },
    { name: { it: "Toast", en: "Toast", de: "Toast" }, desc: { it: "Prosciutto cotto e mozzarella.", en: "Cooked ham and mozzarella.", de: "Gekochter Schinken und Mozzarella." }, price: "€5,90" },
    { name: { it: "Scones", en: "Scones", de: "Scones" }, desc: { it: "Burro, marmellata della casa.", en: "Butter, house jam.", de: "Butter, hausgemachte Marmelade." }, price: "€4,50" },
    { name: { it: "Cannoli siciliani", en: "Sicilian Cannoli", de: "Sizilianische Cannoli" }, desc: { it: "Ricotta fresca, scaglie di pistacchio.", en: "Fresh ricotta, pistachio flakes.", de: "Frische Ricotta, Pistazienflocken." }, price: "€4,90" },
  ],
  lunch: [
    { name: { it: "Pizza Margherita", en: "Margherita Pizza", de: "Pizza Margherita" }, desc: { it: "Pomodoro San Marzano, mozzarella, basilico.", en: "San Marzano tomato, mozzarella, basil.", de: "San-Marzano-Tomate, Mozzarella, Basilikum." }, price: "€9,95" },
    { name: { it: "Pizza Diavola", en: "Diavola Pizza", de: "Pizza Diavola" }, desc: { it: "Salame piccante, peperoncino.", en: "Spicy salami, chili.", de: "Scharfe Salami, Chili." }, price: "€10,95" },
    { name: { it: "Pollo Pancetta", en: "Pollo Pancetta", de: "Pollo Pancetta" }, desc: { it: "Petto di pollo, pancetta croccante, porri, salsa cremosa.", en: "Chicken breast, crispy bacon, leek, creamy sauce.", de: "Hähnchenbrust, knuspriger Speck, Lauch, cremige Sauce." }, price: "€14,95" },
    { name: { it: "Lasagne al forno", en: "Baked Lasagna", de: "Lasagne al forno" }, desc: { it: "Ragù di manzo, besciamella, mozzarella.", en: "Beef ragù, béchamel, mozzarella.", de: "Rindergulasch, Béchamel, Mozzarella." }, price: "€10,95" },
  ],
  dessert: [
    { name: { it: "Tiramisù", en: "Tiramisu", de: "Tiramisu" }, desc: { it: "Mascarpone, savoiardi, caffè espresso.", en: "Mascarpone, ladyfingers, espresso.", de: "Mascarpone, Löffelbiskuit, Espresso." }, price: "€7,50" },
    { name: { it: "Panna cotta", en: "Panna Cotta", de: "Panna Cotta" }, desc: { it: "Vaniglia bourbon, salsa ai frutti rossi.", en: "Bourbon vanilla, red berry sauce.", de: "Bourbon-Vanille, rote Beeren-Sauce." }, price: "€6,50" },
    { name: { it: "Cantuccini & Vin Santo", en: "Cantuccini & Vin Santo", de: "Cantuccini & Vin Santo" }, desc: { it: "Biscotti alle mandorle, vino dolce toscano.", en: "Almond biscuits, sweet Tuscan wine.", de: "Mandelkekse, süßer toskanischer Wein." }, price: "€7,90" },
  ],
};

export const venueImages = {
  // Real photos of Caffè & Cucina Sorriso, Plinganserstraße 38A, München
  // Sources: coffeenewstom blog (clean editorial photos) + haco/didaudo (Google listing photos)
  hero: "https://coffeenewstomblog.com/wp-content/uploads/2019/06/20190603_173131.jpg",
  exterior: "https://coffeenewstomblog.com/wp-content/uploads/2019/06/20190603_185330.jpg",
  coffee: "https://coffeenewstomblog.com/wp-content/uploads/2019/06/20190603_173143.jpg",
  interior1: "https://img-us.didaudo.net/us-res/DE/000/080/80004.jpg",
  interior2: "https://img-us.didaudo.net/us-res/DE/000/080/80014.jpg",
  interior3: "https://img-us.didaudo.net/us-res/DE/000/080/80017.jpg",
  dish1: "https://img-us.didaudo.net/us-res/DE/000/080/80043.jpg",
  dish2: "https://img-us.didaudo.net/us-res/DE/000/080/80049.jpg",
};
